import API from './api';

export default class BalanceApi {
  static getList(params) {
    return API.get('/advertisers/advertiser_balances', params);
  }
}
